@if (positionTooltip === 'topCenter') {
  <div [class.actions]="actions" [class.inside-table]="insideTable" class="top-center">
    <div class="top-center__content {{ textAlign }} {{ customClass }}">
      {{ tooltipText }}
    </div>
  </div>
} @if (positionTooltip === 'topRight') {
  <div [class.actions]="actions" [class.inside-table]="insideTable" class="top-right">
    <div class="top-right__content {{ textAlign }} {{ customClass }}">
      {{ tooltipText }}
    </div>
  </div>
} @if (positionTooltip === 'leftCenter') {
  <div [class.actions]="actions" [class.inside-table]="insideTable" class="left-center">
    <div class="left-center__content {{ textAlign }} {{ customClass }}">
      {{ tooltipText }}
    </div>
  </div>
} @if (positionTooltip === 'topLeft') {
  <div [class.actions]="actions" [class.inside-table]="insideTable" class="top-left">
    <div class="top-left__content {{ textAlign }} {{ customClass }}">
      {{ tooltipText }}
    </div>
  </div>
} @if (positionTooltip === 'bottomCenter') {
  @if (patientSignerSaved) {
    <div
      [class.actions]="actions"
      [class.inside-table]="insideTable"
      [class.representative-tooltip]="!!patientSignerSaved"
      class="bottom-center">
      <div class="bottom-center__content">
        @if (relationshipTooltipText) {
          <div class="representative-row">
            <strong>Relationship:</strong> {{ relationshipTooltipText }}{{ patientSignerSaved?.fullName || patientSignerSaved?.reason ? ';' : '' }}
          </div>
        } @if (patientSignerSaved?.fullName) {
        <div class="representative-row">
          <strong>Full
            name:</strong> {{ patientSignerSaved?.fullName ?? '' }}{{ patientSignerSaved?.reason ? ';' : '' }}
        </div>
      } @if (patientSignerSaved?.reason) {
        <div class="representative-row">
          <strong>Reason:</strong> {{ patientSignerSaved?.reason ?? '' }}
        </div>
      }
      </div>
    </div>
  } @else {
    <div
      [class.actions]="actions"
      [class.inside-table]="insideTable"
      class="bottom-center">
      <div class="bottom-center__content {{ textAlign }}">
        {{ tooltipText }}
      </div>
    </div>
  }
}
